import Button from "@mui/material/Button";
import i18n from "../../../../constants/i18n";
import getUserMessagesStore from "../../../../stores/user-store/messages-store";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";

const LoadMoreButton = withLiteObserverAndTheme(() => {
  const shouldShow = getUserMessagesStore().shouldShowLoadMoreButton.get();

  return shouldShow ? (
    <Button
      variant="outlined"
      onClick={async () => {
        await getUserMessagesStore().getUserMessages({
          isLoadMore: true
        });
      }}
      sx={{ alignSelf: "center", whiteSpace: "nowrap" }}
    >
      {i18n.get("LOAD_MORE")}
    </Button>
  ) : null;
});
export default LoadMoreButton;
